import { Storage } from "../../storage"
import api from "../api"

export class AuthService {
    static pathBase = "/users/"

    static async login(body: {
        identification: string
        password: string,
        role: number
    }) {
        return api.post(this.pathBase + "login", {
            ...body,
            role: body.role
        })
    }

    static async refresh(token: string) {
        return api.post(this.pathBase + "refresh-token", {
            token
        })
    }

    static async logout() {
        const { refresh } = await Storage.getTokens()
        api.post(this.pathBase + "logout", {
            token: refresh
        })
        Storage.clearAll()
        window.location.reload()
    }

    static async me() {
        return api.get(this.pathBase + "me")
    }

    static async redefinePassword(body: {
        token: string,
        password: string,
        userId: string,
        role: number
    }) {
        return api.post(this.pathBase + "redefine-password", body)
    }

    static async recoverPassword(identification: string, role: number) {
        return api.post(this.pathBase + "request-redefine-password", {
            identification,
            role
        })
    }
}